var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.values,"label":"Loja Teste","item-text":"text","item-value":"value"},model:{value:(_vm.valueSelecionado),callback:function ($$v) {_vm.valueSelecionado=$$v},expression:"valueSelecionado"}})}
var staticRenderFns = []

export { render, staticRenderFns }